import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ChangerDeMDP from './ChangerDeMDP/ChangerDeMDP';
import Bouton from '../UI/Bouton/Bouton';
import * as actions from '../../services/actions';
import { stringArray } from '../../ressources/functionJS/stringArray';
import * as type_btn from '../../ressources/glossaires/glossaire_type_de_bouton';
import { checkMot } from '../../ressources/functionJS/checkMot';
import { MdDone, MdClose, MdModeEdit } from 'react-icons/md';
import S from './Profil.module.scss';
import * as s from '../../ressources/StyleGlobal/StyleGlobal';

const Profil = () => {
  const dispatch = useDispatch();

  // Redux state
  const user_id = useSelector((state) => state.authentifie.user_id);
  const lastname = useSelector((state) => state.authentifie.lastname);
  const name = useSelector((state) => state.authentifie.name);
  const privileges_list = useSelector(
    (state) => state.authentifie.privileges_list
  );
  const email = useSelector((state) => state.authentifie.email);
  const phone_index = useSelector((state) => state.authentifie.phone_index);
  const phone_number = useSelector((state) => state.authentifie.phone_number);
  const company_name = useSelector((state) => state.authentifie.company_name);
  const projects_list = useSelector((state) => state.authentifie.projects_list);
  const validationChangementMotDePasse = useSelector(
    (state) => state.authentifie.validationChangementMotDePasse
  );

  // Local state with multiple useState hooks
  const [prenom, setPrenom] = useState(lastname);
  const [nom, setNom] = useState(name);
  const [emailState, setEmailState] = useState(email);
  const [indexTelephone, setIndexTelephone] = useState(phone_index);
  const [numeroTelephone, setNumeroTelephone] = useState(phone_number);
  const [entreprise, setEntreprise] = useState(company_name);
  const [
    afficheFormulaireDeModificationBool,
    setAfficheFormulaireDeModificationBool,
  ] = useState(false);
  const [
    afficheFormulaireDeModificationMDPBool,
    setAfficheFormulaireDeModificationMDPBool,
  ] = useState(false);

  // Event handlers
  const handlePrenom = (event) => setPrenom(event.target.value);
  const handleNom = (event) => setNom(event.target.value);
  const handleEmail = (event) => setEmailState(event.target.value);
  const handleEntreprise = (event) => setEntreprise(event.target.value);
  const handleNumeroTelephone = (event) =>
    setNumeroTelephone(event.target.value);
  const handleIndexTelephone = (event) => setIndexTelephone(event.target.value);

  const handleModifierFormulaire = () =>
    setAfficheFormulaireDeModificationBool(true);
  const handleModifierFormulaireMDP = () =>
    setAfficheFormulaireDeModificationMDPBool(true);
  const handleAnnulerModification = () =>
    setAfficheFormulaireDeModificationBool(false);
  const handleAnnulerModificationMDP = () =>
    setAfficheFormulaireDeModificationMDPBool(false);

  const handleEnvoieModifierFormulaire = () => {
    const formulaireDeModificationUtilisateur = {
      user_id,
      login_name: emailState,
      name: nom,
      lastname: prenom,
      email: emailState,
      phone_number: numeroTelephone,
      phone_index: indexTelephone,
      company_name: entreprise,
      active: 1,
      privileges_list,
      projects_list_id: Object.keys(projects_list).map(
        (indProjet) => projects_list[indProjet].project_id
      ),
    };
    dispatch(
      actions.reqModifierUtilisateur(formulaireDeModificationUtilisateur)
    );
  };

  const handleChangerMDP = (mdpActuel, nouveauMDP, confirmationNouveauMDP) => {
    dispatch(
      actions.reqChangerMDP(mdpActuel, nouveauMDP, confirmationNouveauMDP)
    );
  };

  const profileView = (
    <>
      <div className={[S.ppro, s.card].join(' ')}>
        <div className={[s.row, s.card_body].join(' ')}>
          <div className={s.col}>
            <div className={[s.col_md_auto, S.label_profil].join(' ')}>
              {checkMot('nom_de_famille')}
            </div>
            <div className={s.col_md_auto}>
              <input
                className={S.text_general_a}
                value={lastname}
                readOnly={true}
              />
            </div>

            <div className={[s.col_md_auto, S.label_profil].join(' ')}>
              {checkMot('prenom')}
            </div>
            <div className={s.col_md_auto}>
              <input
                className={S.text_general_a}
                value={name}
                readOnly={true}
              />
            </div>

            <div className={[s.col_md_auto, S.label_profil].join(' ')}>
              {checkMot('privilege_list')}
            </div>
            <div className={s.col_md_auto}>
              <input
                className={S.text_general_a}
                value={
                  privileges_list !== undefined
                    ? privileges_list.join(', ')
                    : ''
                }
                readOnly={true}
              />
            </div>

            <div className={[s.col_md_auto, S.label_profil].join(' ')}>
              {checkMot('email')}
            </div>
            <div className={s.col_md_auto}>
              <input
                className={S.text_general_a}
                value={email}
                readOnly={true}
              />
            </div>
          </div>
          <div className={s.col}>
            <div className={[s.col_md_auto, S.label_profil].join(' ')}>
              {checkMot('phone_index')}:
            </div>
            <div className={s.col_md_auto}>
              <input
                className={[S.text_general_a].join(' ')}
                value={phone_index}
                readOnly={true}
              />
            </div>

            <div className={[s.col_md_auto, S.label_profil].join(' ')}>
              {checkMot('numero_de_telephone')}:
            </div>
            <div className={s.col_md_auto}>
              <input
                className={[S.text_general_a].join(' ')}
                value={phone_number}
                readOnly={true}
              />
            </div>

            <div className={[s.col_md_auto, S.label_profil].join(' ')}>
              {checkMot('company_name')}
            </div>
            <div className={[s.col_md_auto, S.label_profil].join(' ')}>
              <input
                className={S.text_general_a}
                value={company_name}
                readOnly={true}
              />
            </div>
          </div>
          <div className={s.col_12}>
            <div className={s.row}>
              <div className={[s.col_md_auto, S.btnModifierB1].join(' ')}>
                <Bouton cliquer={handleModifierFormulaire}>
                  <MdModeEdit />
                  {checkMot('modifier')}
                </Bouton>
              </div>
              <div className={[s.col_md_auto, S.btnModifierB2].join(' ')}>
                <Bouton cliquer={handleModifierFormulaireMDP}>
                  <MdModeEdit /> {checkMot('changer_mot_de_passe')}
                </Bouton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
  /**
   * Formulaires
   **/
  const editForm = (
    <>
      <div className={[S.ppro, s.card].join(' ')}>
        <div className={[s.row, s.card_body].join(' ')}>
          <div className={s.col}>
            <div className={[s.col_md_auto, S.label_profil].join(' ')}>
              {checkMot('nom')}
            </div>
            <div className={s.col_md_auto}>
              <input
                className={S.text_general}
                value={prenom}
                onChange={handlePrenom}
                placeholder={lastname}
              />
            </div>

            <div className={[s.col_md_auto, S.label_profil].join(' ')}>
              {checkMot('prenom')}
            </div>
            <div className={s.col_md_auto}>
              <input
                className={S.text_general}
                value={nom}
                onChange={handleNom}
                placeholder={name}
              />
            </div>

            <div className={[s.col_md_auto, S.label_profil].join(' ')}>
              {checkMot('privilege_list')}
            </div>
            <div className={s.col_md_auto}>
              <input
                className={S.text_general}
                value={stringArray(privileges_list)}
                readOnly={true}
              />
            </div>

            <div className={[s.col_md_auto, S.label_profil].join(' ')}>
              {checkMot('email')}
            </div>
            <div className={s.col_md_auto}>
              <input
                className={S.text_general}
                value={email}
                onChange={handleEmail}
                placeholder={email}
                readOnly={true}
              />
            </div>
          </div>
          <div className={s.col}>
            <div className={[s.col_md_auto, S.label_profil].join(' ')}>
              {checkMot('phone_index')}
            </div>
            <div className={s.col_md_auto}>
              <input
                className={S.text_general}
                value={indexTelephone}
                onChange={handleIndexTelephone}
                placeholder={phone_index}
              />
            </div>

            <div className={[s.col_md_auto, S.label_profil].join(' ')}>
              {checkMot('numero_de_telephone')}
            </div>
            <div className={s.col_md_auto}>
              <input
                className={S.text_general}
                value={numeroTelephone}
                onChange={handleNumeroTelephone}
                placeholder={phone_number}
              />
            </div>

            <div className={[s.col_md_auto, S.label_profil].join(' ')}>
              {checkMot('company_name')}
            </div>
            <div className={s.col_md_auto}>
              <input
                className={S.text_general}
                value={entreprise}
                onChange={handleEntreprise}
                placeholder={company_name}
              />
            </div>
          </div>
          <div className={s.col_12}>
            <div className={s.row}>
              <div className={[s.col_md_auto, S.btnModifierB1A].join(' ')}>
                <Bouton
                  cliquer={handleAnnulerModification}
                  type={type_btn.danger}
                >
                  <MdClose /> {checkMot('annuler')}
                </Bouton>
              </div>
              <div className={[s.col_md_auto, S.btnModifierB1B].join(' ')}>
                <Bouton
                  cliquer={handleEnvoieModifierFormulaire}
                  type={type_btn.succes}
                >
                  <MdDone /> {checkMot('envoyer')}
                </Bouton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
  return (
    <div className={S.Profil}>
      {afficheFormulaireDeModificationMDPBool ? (
        <ChangerDeMDP
          validationChangementMotDePasse={validationChangementMotDePasse}
          changerDeMDP={handleChangerMDP}
          idUtilisateur={user_id}
          annulerModificationMDP={handleAnnulerModificationMDP}
        />
      ) : (
        <>
          <div className={[S.profilH1, s.card_header].join(' ')}>
            {checkMot('profil')}
          </div>
          {afficheFormulaireDeModificationBool ? editForm : profileView}
        </>
      )}
    </div>
  );
};

export default Profil;
